import { render, staticRenderFns } from "./TabPricing.vue?vue&type=template&id=b6f99da6&scoped=true"
import script from "./TabPricing.vue?vue&type=script&lang=js"
export * from "./TabPricing.vue?vue&type=script&lang=js"
import style0 from "./TabPricing.vue?vue&type=style&index=0&id=b6f99da6&prod&lang=scss&scoped=true"
import style1 from "./TabPricing.vue?vue&type=style&index=1&id=b6f99da6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f99da6",
  null
  
)

export default component.exports